import { useState, useCallback } from "react";

export const useAppConfig = () => {
    // TODO: Change this to get the languages list from the server
    const [language, setLanguage] = useState("English");
    const [isFirstHomePageLoad, setIsHomeFirstPageLoad] = useState(true);

    const acceptedLanguages = ["English", "Portugues"];

    const changeLanguage = useCallback(language => {
        setLanguage(language);
    }, []);

    const onFirstHomePageLoad = useCallback(() => {
        setIsHomeFirstPageLoad(false);
    }, []);

    return {
        language,
        changeLanguage,
        acceptedLanguages,
        isFirstHomePageLoad,
        onFirstHomePageLoad
    };
};
